import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BLink } from "bootstrap-vue";
import { computed, ref, watch } from "vue";
import { Services } from "@/components/Workflow/services";
export default /*#__PURE__*/ _defineComponent({
    __name: 'TrsServerSelection',
    props: {
        queryTrsServer: null,
        trsSelection: null
    },
    emits: ["onError", "onTrsSelection"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faCaretDown);
        const loading = ref(true);
        const selection = ref(null);
        const trsServers = ref([]);
        const trsSelectionLookup = ref(null);
        const showDropdown = computed(() => {
            return trsServers.value.length > 1;
        });
        watch(props, () => {
            selection.value = props.trsSelection ?? null;
        });
        const services = new Services();
        async function configureTrsServers() {
            const servers = await services.getTrsServers();
            const queryTrsServer = props.queryTrsServer;
            trsServers.value = servers;
            if (queryTrsServer) {
                for (const server of servers) {
                    if (server.id == queryTrsServer) {
                        trsSelectionLookup.value = server;
                        break;
                    }
                    if (possibleServeUrlsMatch(server.api_url, queryTrsServer)) {
                        trsSelectionLookup.value = server;
                        break;
                    }
                    if (possibleServeUrlsMatch(server.link_url, queryTrsServer)) {
                        trsSelectionLookup.value = server;
                        break;
                    }
                }
            }
            if (trsSelectionLookup.value === null) {
                if (queryTrsServer) {
                    emit("onError", "Failed to find requested TRS server " + queryTrsServer);
                }
                trsSelectionLookup.value = servers[0];
            }
            selection.value = trsSelectionLookup.value;
            loading.value = false;
            onTrsSelection(trsSelectionLookup.value);
        }
        configureTrsServers();
        function onTrsSelection(newSelection) {
            selection.value = newSelection;
            emit("onTrsSelection", newSelection);
        }
        function possibleServeUrlsMatch(a, b) {
            // let http://trs_server.org/ match with https://trs_server.org for instance,
            // we'll only use the one configured on the backend for making actual calls, but
            // allow some robustness in matching it
            a = a.replace(/^https?:\/\//, "").replace(/\/$/, "");
            b = b.replace(/^https?:\/\//, "").replace(/\/$/, "");
            return a === b;
        }
        return { __sfc: true, props, emit, loading, selection, trsServers, trsSelectionLookup, showDropdown, services, configureTrsServers, onTrsSelection, possibleServeUrlsMatch, faCaretDown, FontAwesomeIcon, BLink };
    }
});
